import { render } from "./daythree.vue?vue&type=template&id=96020fe0"
import script from "./daythree.vue?vue&type=script&lang=js"
export * from "./daythree.vue?vue&type=script&lang=js"

import "./daythree.vue?vue&type=style&index=0&id=96020fe0&lang=scss"
script.render = render

export default script